module.exports = __webpack_public_path__ + "img/apple_tree.be5030ca.webp";